import { extend } from 'umi-request';

const ajax = extend({});

let scope = {};

interface reportData {
  [key: string]: any;
}

interface scopeFn {
  (data: reportData): reportData;
}

export function elkReport(data: reportData | undefined) {
  return ajax.post('https://sigma-webmeeting-popo.proxima.nie.easebar.com', {
    data: Object.assign(data || {}, scope),
    headers: {
      'Content-Type': 'application/json',
      'X-Auth-User': 'popo',
      'X-Auth-Token':
        'rc4w73moItQlkLIxbAhCWPEXzPOGUVGYSwLmoxGuO21CLm5ggT8FDTp+fZPD4brqaSWP3ryyvT7TuQdSRz2YFnFrqKZNkj6M1LSEe9DJqABMwYLDRmN3cYCAeuG6+6qV',
    },
    responseType: 'text',
  });
}

// elk上报日志
export function elkLog(type: string, TagObj?: Record<string, any>, data?: Record<string, any>) {
  elkReport({ ...TagObj, type, logData: data }).catch((e) => console.error(e));
}

export function setElkScope(scopeData: reportData | scopeFn) {
  if (typeof scopeData === 'function') {
    scope = scopeData(scope);
  } else {
    scope = Object.assign(scope, scopeData);
  }
  elkReport({ type: 'elk上报', logData: scope });
}

export function getElkScope() {
  return scope;
}
